<template>
  <div>
    <Head title="商品列表設定" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <product-carousel-template>
      <div class="w-full flex flex-row items-center justify-end gap-4">
        <Button label="新增" @click="addPc" />
        <Button label="儲存" @click="savePc" />
      </div>

      <div class="w-full pt-3">
        <div
          :key="getItemKey(pc)"
          v-for="(pc, pc_index) in pcs"
          class="w-full item"
        >
          <div class="flex flex-row jusitfy-between items-begin gap-2">
            <div>
              <div class="mt-1">
                <label :for="'random_' + getItemKey(pc)">亂序</label>
              </div>
              <div class="mt-1">
                <InputSwitch
                  :id="'random_' + getItemKey(pc)"
                  v-model="pc.random_order"
                />
              </div>
            </div>
            <div>
              <div class="mt-1">
                <label :for="'group_' + getItemKey(pc)">群組</label>
              </div>
              <div class="mt-1">
                <InputText
                  style="width: 100px"
                  :id="'group_' + getItemKey(pc)"
                  v-model="pc.group"
                />
              </div>
            </div>
            <div>
              <div class="mt-1">
                <label :for="'title_' + getItemKey(pc)">標題</label>
              </div>
              <div class="mt-1">
                <InputText
                  style="width: 400px"
                  :id="'title_' + getItemKey(pc)"
                  v-model="pc.title"
                />
              </div>
            </div>
            <div>
              <div class="mt-1">
                <label :for="'del_' + getItemKey(pc)">刪除</label>
              </div>
              <div class="mt-1">
                <div>
                  <Button
                    class="p-button-danger"
                    :id="'del_' + getItemKey(pc)"
                    label="刪除"
                    @click="delPc(pc, pc_index)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="relative h-[80px] mt-2">
            <div class="flex flex-row relative py-2">
              <div
                class="h-[50px] w-[50px] min-w-[50px] cursor-pointer flex flex-col items-center justify-center bg-fh-gray-light"
                @click="addProduct(pc_index)"
              >
                <i
                  class="pi pi-plus transition-transform"
                  style="font-size: 1.2rem; line-height: 25px"
                />
                <span>新增</span>
              </div>
              <div class="absolute inset-0 ml-[60px]">
                <Draggable
                  v-model="pc.all_product_info"
                  class="py-2 overflow-x-auto flex flex-row gap-x-2"
                >
                  <template v-for="(product, index) in pc.all_product_info">
                    <div
                      v-if="
                        Array.isArray(product.images) &&
                        product.images.length > 0
                      "
                      :key="'selected_product_' + index"
                      class="relative w-[50px] h-[50px] min-w-[50px] bg-fh-gray-light flex items-center justify-center bg-cover bg-center cursor-move"
                      :style="{
                        'background-image':
                          'url(\'/storage/product-images/' +
                          product.images[0] +
                          '/50.jpg\')',
                      }"
                      v-tooltip.bottom="
                        product.type == 'merchandise'
                          ? '[商品] ' + product.name
                          : '[組合包] ' + product.name
                      "
                    >
                      <div
                        class="absolute top-[-7px] right-[-7px] cursor-pointer"
                        @click="removeProduct(pc_index, index)"
                      >
                        <Badge severity="danger" value="Ｘ" />
                      </div>
                    </div>
                    <div
                      v-else
                      :key="'selected_product_' + index"
                      class="relative w-[50px] h-[50px] min-w-[50px] bg-fh-gray-light flex items-center justify-center bg-cover bg-center cursor-move"
                      v-tooltip.bottom="
                        product.type == 'merchandise'
                          ? '[商品] ' + product.name
                          : '[組合包] ' + product.name
                      "
                    >
                      無
                      <div
                        class="absolute top-[-7px] right-[-7px] cursor-pointer"
                        @click="removeProduct(pc_index, index)"
                      >
                        <Badge severity="danger" value="Ｘ" />
                      </div>
                    </div>
                  </template>
                </Draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </product-carousel-template>
    <Dialog :visible.sync="show_dialog" :modal="true">
      <div class="w-full h-full">
        <DataTable
          :value="
            products.filter((product) => {
              return product.name.includes(this.product_search);
            })
          "
          :selection.sync="selectedProduct"
        >
          <template #header>
            <div class="flex justify-between items-center">
              <div></div>
              <div class="flex flex-row items-center gap-2">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    class="w-52"
                    v-model="product_search"
                    placeholder="搜尋商品"
                  />
                </span>
              </div>
            </div>
          </template>
          <Column headerClass="w-11" selectionMode="single"></Column>
          <Column headerClass="w-14" field="images" header="圖片">
            <template #body="slotProps">
              <template
                v-if="
                  Array.isArray(slotProps.data.images) &&
                  slotProps.data.images.length > 0
                "
              >
                <div
                  class="w-[50px] h-[50px] bg-fh-gray-light flex items-center justify-center bg-cover bg-center"
                  :style="{
                    'background-image':
                      'url(\'/storage/product-images/' +
                      slotProps.data.images[0] +
                      '/50.jpg\')',
                  }"
                ></div>
              </template>
              <template v-else>
                <div
                  class="w-[50px] h-[50px] bg-fh-gray-light flex items-center justify-center"
                >
                  無
                </div>
              </template>
            </template>
          </Column>
          <Column headerClass="w-18" field="type" header="商品類型" sortable>
            <template #body="slotProps">
              <template v-if="slotProps.data.type == 'pack'">組合包</template>
              <template v-if="slotProps.data.type == 'merchandise'"
                >商品</template
              >
            </template>
          </Column>
          <Column headerClass="w-60" field="name" header="商品名稱" sortable>
          </Column>
          <!-- <Column
            headerClass="w-24"
            field="available"
            header="商品狀態"
            sortable
          >
            <template #body="slotProps">
              <Tag
                class="mr-2"
                :severity="slotProps.data.available == 1 ? 'success' : 'danger'"
              >
                {{ slotProps.data.available == 1 ? "上架中" : "未上架" }}
              </Tag>
            </template>
          </Column> -->
        </DataTable>
      </div>
      <template #footer>
        <div class="mt-2">
          <Button
            label="新增商品"
            :disabled="selectedProduct == null"
            @click="addProductToPC"
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import ProductCarouselTemplate from "./Shared/ProductCarouselTemplate";
import Button from "primevue/button";
import Draggable from "vuedraggable";
import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import Badge from "primevue/badge";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Tag from "primevue/tag";

export default {
  components: {
    ScrollTop,
    Breadcrumb,
    ProductCarouselTemplate,
    Button,
    Draggable,
    InputText,
    InputSwitch,
    Badge,
    Dialog,
    DataTable,
    Column,
    Tag,
  },
  layout: Layout,
  computed: {
    //
  },
  data() {
    return {
      breadcrumb_home: {
        label: "頁面管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "商品列表設定",
          to: route("admin.pc"),
          disabled: !decodeURI(this.$page.url).includes("group"),
        },
        {
          label: this.$page.props.breadcrumb_label,
          disabled: true,
        },
      ],
      isUploading: false,
      isEditing: false,
      pcs: this.$page.props.pcs ?? [],
      pcs_del: [],
      show_dialog: false,
      products: [],
      selectedProduct: null,
      product_search: "",
      target_product: null,
    };
  },
  methods: {
    getItemKey(item) {
      if (item.id == null) return item.random;
      else return item.id;
    },
    addPc() {
      this.pcs.unshift({
        id: null,
        group: null,
        random: Math.random().toString(36).substring(2),
        products: [],
        all_product_info: [],
        random_order: false,
      });
    },
    savePc() {
      this.pcs = this.pcs.filter((pc) => {
        return pc.all_product_info != null;
      });

      this.pcs_del = this.pcs_del.filter((pc) => {
        return pc.all_product_info != null || pc.id == null;
      });

      this.pcs.forEach((pc) => {
        pc.products = pc.all_product_info.map((pc_info) => {
          return pc_info.key;
        });
      });

      this.$inertia.post(
        route("admin.pc.save"),
        {
          pcs: this.pcs,
          pcs_del: this.pcs_del,
        },
        {
          only: ["pcs", "groups", "flash"],
          onSuccess: (page) => {
            this.pcs = page.props.pcs;
            this.pcs_del = [];
          },
        }
      );
    },
    addProduct(pc_index) {
      this.selectedProduct = null;
      axios.get(route("admin.fetch.products")).then((response) => {
        this.products = response.data;
        this.target_product = pc_index;
        this.show_dialog = true;
      });
    },
    addProductToPC() {
      this.pcs[this.target_product].all_product_info.push(this.selectedProduct);
      // this.show_dialog = false;
      // this.target_product = null;
    },
    removeProduct(pc_index, index) {
      this.pcs[pc_index].all_product_info.splice(index, 1);
    },
    delPc(pc, index) {
      this.pcs_del.push(pc);
      this.pcs.splice(index, 1);
    },
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}

.item {
  @apply relative border rounded border-fh-gray-light p-2 mb-2;
}
</style>

<style>
.current_destination {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>